/**
 * Helper function that converts root or newsAdmin color variables with a valid color system value.
 */
export default function convertVariableColor(color) {
  const root = getComputedStyle(document.querySelector("body"));

  const newsAdminVariables = [
    { color: "#FFF", name: "default" },
    { color: "#ffffff", name: "color-a" },
    { color: "#000000", name: "color-b" },
    { color: "#243746", name: "strength" },
    { color: "#415364", name: "empowerment" },
    { color: "#91b6bb", name: "inspiration" },
    { color: "#7F6A45", name: "stability" },
    { color: "#9E703C", name: "authenticity" },
    { color: "#ADB7C0", name: "balance" },
    { color: "#A89C96", name: "connection" },
  ];

  // Returns null if there is no respective variable
  return root.getPropertyValue(color).length
    ? root.getPropertyValue(color).trim()
    : newsAdminVariables.filter(({ name }) => name === color)[0]?.color;
}
